/**
 * @generated SignedSource<<9da80d91361bb7b7d163adae17cbd600>>
 * @relayHash 3fd70edb43a9af4db564630bfb5316a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 473880706f8cc6ebfcd6c2018f3381a21889aba1dd03ede8065fc008d2d9b5cb

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchIssueStatusCategory = "DONE" | "INDETERMINATE" | "NEW" | "OPEN" | "UNDEFINED" | "%future added value";
export type SearchLinkedEntityGranularity = "ALL_MATCHING_MESSAGES" | "DEFAULT" | "FULL_THREAD" | "%future added value";
export type SearchParticipantType = "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "%future added value";
export type SearchProjectType = "business" | "customer_service" | "product_discovery" | "service_desk" | "software" | "%future added value";
export type SearchSortOrder = "ASC" | "DESC" | "%future added value";
export type SearchThirdPartyRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null | undefined;
  participants?: SearchParticipants | null | undefined;
  range?: SearchCommonRangeFilter | null | undefined;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null | undefined;
  lastModified?: SearchCommonRangeFilterFields | null | undefined;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null | undefined;
  containerARIs?: ReadonlyArray<string> | null | undefined;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null | undefined> | null | undefined;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null | undefined;
  contributorsFilter?: ReadonlyArray<string> | null | undefined;
  creatorsFilter?: ReadonlyArray<string> | null | undefined;
  isVerified?: boolean | null | undefined;
  labelsFilter?: ReadonlyArray<string> | null | undefined;
  mentions?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
  pageStatus?: ReadonlyArray<string> | null | undefined;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null | undefined> | null | undefined;
  spacesFilter?: ReadonlyArray<string> | null | undefined;
  titleMatchOnly?: boolean | null | undefined;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchJiraFilter = {
  boardFilter?: SearchBoardFilter | null | undefined;
  issueFilter?: SearchJiraIssueFilter | null | undefined;
  projectFilter?: SearchJiraProjectFilter | null | undefined;
};
export type SearchBoardFilter = {
  negateProjectFilter?: boolean | null | undefined;
  projectARI?: string | null | undefined;
  userARI?: string | null | undefined;
};
export type SearchJiraIssueFilter = {
  assigneeARIs?: ReadonlyArray<string> | null | undefined;
  commenterARIs?: ReadonlyArray<string> | null | undefined;
  issueLabels?: ReadonlyArray<string> | null | undefined;
  issueTypeIDs?: ReadonlyArray<string> | null | undefined;
  issueTypes?: ReadonlyArray<string> | null | undefined;
  projectARIs?: ReadonlyArray<string> | null | undefined;
  reporterARIs?: ReadonlyArray<string> | null | undefined;
  statusCategories?: ReadonlyArray<SearchIssueStatusCategory> | null | undefined;
  watcherARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchJiraProjectFilter = {
  projectType?: SearchProjectType | null | undefined;
  projectTypes?: ReadonlyArray<SearchProjectType> | null | undefined;
};
export type SearchAssetsFilter = {
  objectSchemaFilter?: SearchAssetsObjectSchemaFilter | null | undefined;
  objectTypeFilter?: SearchAssetsObjectTypeFilter | null | undefined;
};
export type SearchAssetsObjectSchemaFilter = {
  schemaARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchAssetsObjectTypeFilter = {
  typeARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchMercuryFilter = {
  ancestorIds?: ReadonlyArray<string> | null | undefined;
  focusAreaTypeIds?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
};
export type SearchTalentFilter = {
  employmentTypes?: ReadonlyArray<string> | null | undefined;
  focusAreas?: ReadonlyArray<string> | null | undefined;
  jobFamilies?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
  statuses?: ReadonlyArray<string> | null | undefined;
  teams?: ReadonlyArray<string> | null | undefined;
};
export type SearchCompassFilter = {
  componentFilter?: SearchCompassComponentFilter | null | undefined;
};
export type SearchCompassComponentFilter = {
  componentStates: ReadonlyArray<string>;
};
export type SearchThirdPartyFilter = {
  additionalTexts?: ReadonlyArray<string> | null | undefined;
  ancestorAris?: ReadonlyArray<string> | null | undefined;
  assignees?: ReadonlyArray<string> | null | undefined;
  containerAris?: ReadonlyArray<string> | null | undefined;
  containerNames?: ReadonlyArray<string> | null | undefined;
  containerTypes?: ReadonlyArray<string> | null | undefined;
  createdBy?: ReadonlyArray<string> | null | undefined;
  excludeSubtypes?: ReadonlyArray<string> | null | undefined;
  integrations?: ReadonlyArray<string> | null | undefined;
  labels?: ReadonlyArray<string> | null | undefined;
  lastUpdatedBy?: ReadonlyArray<string> | null | undefined;
  range?: ReadonlyArray<SearchThirdPartyRangeFilter | null | undefined> | null | undefined;
  subtypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  teamsFilters?: SearchTeamsFilters | null | undefined;
  thirdPartyProducts?: ReadonlyArray<SearchThirdPartyProduct> | null | undefined;
  thirdPartyTypes?: ReadonlyArray<string> | null | undefined;
  titleMatchOnly?: boolean | null | undefined;
};
export type SearchThirdPartyRangeFilter = {
  field: SearchThirdPartyRangeField;
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchTeamsFilters = {
  attachmentFileTypes?: ReadonlyArray<string> | null | undefined;
  hasAttachment?: boolean | null | undefined;
  hasLink?: boolean | null | undefined;
};
export type SearchThirdPartyProduct = {
  connectionIds?: ReadonlyArray<string> | null | undefined;
  connectorSources?: ReadonlyArray<string> | null | undefined;
  containerTypes?: ReadonlyArray<string> | null | undefined;
  datasourceId?: string | null | undefined;
  entities?: ReadonlyArray<string> | null | undefined;
  integrationId?: string | null | undefined;
  linkedEntityGranularity?: SearchLinkedEntityGranularity | null | undefined;
  product?: string | null | undefined;
  providerId?: string | null | undefined;
  subtypes?: ReadonlyArray<string> | null | undefined;
};
export type SearchSortInput = {
  field: string;
  key?: string | null | undefined;
  order: SearchSortOrder;
};
export type SearchExperimentLayer = {
  definitions?: ReadonlyArray<SearchLayerDefinition | null | undefined> | null | undefined;
  layerId?: string | null | undefined;
  name?: string | null | undefined;
  shadowId?: string | null | undefined;
};
export type SearchLayerDefinition = {
  abTestId?: string | null | undefined;
  connectorSources?: ReadonlyArray<string | null | undefined> | null | undefined;
  entity?: string | null | undefined;
  integrationARI?: string | null | undefined;
  layerId?: string | null | undefined;
  providerId?: string | null | undefined;
  shadowId?: string | null | undefined;
  subEntity?: string | null | undefined;
};
export type searchResultsQuery$variables = {
  after?: string | null | undefined;
  assetsFilters?: SearchAssetsFilter | null | undefined;
  cloudIdARI: string;
  commonFilters?: SearchCommonFilter | null | undefined;
  compassFilters?: SearchCompassFilter | null | undefined;
  confluenceFilters?: SearchConfluenceFilter | null | undefined;
  disableQueryReplacement?: boolean | null | undefined;
  enableHighlighting?: boolean | null | undefined;
  entities: ReadonlyArray<string>;
  experience: string;
  experimentId?: string | null | undefined;
  experimentLayers?: ReadonlyArray<SearchExperimentLayer | null | undefined> | null | undefined;
  fanoutExperimentCohort?: string | null | undefined;
  includeAssigneeField?: boolean | null | undefined;
  includeIconUrl?: boolean | null | undefined;
  includeNavBoostScore?: boolean | null | undefined;
  includePositions?: boolean | null | undefined;
  includeThirdPartyId?: boolean | null | undefined;
  jiraFilters?: SearchJiraFilter | null | undefined;
  limit: number;
  mercuryFilters?: SearchMercuryFilter | null | undefined;
  query: string;
  queryVersion?: number | null | undefined;
  searchSessionId?: string | null | undefined;
  sessionId?: string | null | undefined;
  shadowExperimentId?: string | null | undefined;
  sort?: ReadonlyArray<SearchSortInput | null | undefined> | null | undefined;
  sourceProduct?: string | null | undefined;
  talentFilters?: SearchTalentFilter | null | undefined;
  tenantId: string;
  thirdPartyFilters?: SearchThirdPartyFilter | null | undefined;
};
export type searchResultsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage">;
};
export type searchResultsQuery = {
  response: searchResultsQuery$data;
  variables: searchResultsQuery$variables;
};
({
  "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
  "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": isCustomerOrgOwnersEnabled_provider,
  "__relay_internal__pv__isdealownersenabledrelayprovider": isDealOwnersEnabled_provider,
  "__relay_internal__pv__jsmdcenabledrelayprovider": isJsmDcEnabled_provider
} as {
  readonly __relay_internal__pv__isassetsenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__iscustomerorgownersenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isdealownersenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jsmdcenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import includeAssets_provider from './../is-assets-enabled.relayprovider';
import isCustomerOrgOwnersEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-customer-org/is-customer-org-owners-enabled.relayprovider';
import isDealOwnersEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-deal/is-deal-owners-enabled.relayprovider';
import isJsmDcEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-jira-dc/jsm-dc-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetsFilters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdARI"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commonFilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compassFilters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluenceFilters"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disableQueryReplacement"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableHighlighting"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entities"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentId"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentLayers"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fanoutExperimentCohort"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAssigneeField"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeIconUrl"
},
v15 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeNavBoostScore"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePositions"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeThirdPartyId"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraFilters"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mercuryFilters"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryVersion"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchSessionId"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shadowExperimentId"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceProduct"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "talentFilters"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "thirdPartyFilters"
},
v31 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "queryVersion",
        "variableName": "queryVersion"
      },
      {
        "kind": "Variable",
        "name": "searchSessionId",
        "variableName": "searchSessionId"
      },
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      },
      {
        "kind": "Variable",
        "name": "sourceProduct",
        "variableName": "sourceProduct"
      }
    ],
    "kind": "ObjectValue",
    "name": "analytics"
  },
  {
    "kind": "Variable",
    "name": "disableQueryReplacement",
    "variableName": "disableQueryReplacement"
  },
  {
    "kind": "Variable",
    "name": "enableHighlighting",
    "variableName": "enableHighlighting"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "experimentId",
        "variableName": "experimentId"
      },
      {
        "kind": "Variable",
        "name": "experimentLayers",
        "variableName": "experimentLayers"
      },
      {
        "kind": "Variable",
        "name": "shadowExperimentId",
        "variableName": "shadowExperimentId"
      }
    ],
    "kind": "ObjectValue",
    "name": "experimentContext"
  },
  {
    "kind": "Variable",
    "name": "fanoutExperimentCohort",
    "variableName": "fanoutExperimentCohort"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "assetsFilters",
        "variableName": "assetsFilters"
      },
      {
        "kind": "Variable",
        "name": "commonFilters",
        "variableName": "commonFilters"
      },
      {
        "kind": "Variable",
        "name": "compassFilters",
        "variableName": "compassFilters"
      },
      {
        "kind": "Variable",
        "name": "confluenceFilters",
        "variableName": "confluenceFilters"
      },
      {
        "kind": "Variable",
        "name": "entities",
        "variableName": "entities"
      },
      {
        "kind": "Variable",
        "name": "jiraFilters",
        "variableName": "jiraFilters"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "locations.0",
            "variableName": "cloudIdARI"
          }
        ],
        "kind": "ListValue",
        "name": "locations"
      },
      {
        "kind": "Variable",
        "name": "mercuryFilters",
        "variableName": "mercuryFilters"
      },
      {
        "kind": "Variable",
        "name": "talentFilters",
        "variableName": "talentFilters"
      },
      {
        "kind": "Variable",
        "name": "thirdPartyFilters",
        "variableName": "thirdPartyFilters"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  }
],
v32 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v33 = {
  "kind": "ScalarField",
  "name": "id"
},
v34 = {
  "kind": "ScalarField",
  "name": "description"
},
v35 = {
  "kind": "ScalarField",
  "name": "connectorType"
},
v36 = {
  "kind": "ScalarField",
  "name": "title"
},
v37 = {
  "kind": "ScalarField",
  "name": "url"
},
v38 = {
  "kind": "ScalarField",
  "name": "type"
},
v39 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v40 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v41 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v42 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v43 = {
  "kind": "ScalarField",
  "name": "value"
},
v44 = {
  "kind": "ScalarField",
  "name": "label"
},
v45 = [
  (v44/*: any*/)
],
v46 = {
  "kind": "ScalarField",
  "name": "key"
},
v47 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v48 = [
  (v47/*: any*/)
],
v49 = {
  "condition": "includeIconUrl",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v48/*: any*/)
},
v50 = {
  "kind": "ScalarField",
  "name": "name"
},
v51 = [
  (v50/*: any*/)
],
v52 = {
  "kind": "ScalarField",
  "name": "lastModified"
},
v53 = {
  "kind": "ScalarField",
  "name": "total"
},
v54 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v55 = {
  "kind": "ScalarField",
  "name": "picture"
},
v56 = {
  "kind": "ScalarField",
  "name": "email"
},
v57 = [
  {
    "kind": "ScalarField",
    "name": "jobTitle"
  }
],
v58 = {
  "args": [
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    }
  ],
  "concreteType": "SocialSignalSearch",
  "kind": "LinkedField",
  "name": "socialSignal",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "signal"
    },
    {
      "kind": "ScalarField",
      "name": "timestamp"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v32/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v50/*: any*/),
        (v55/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v56/*: any*/),
            {
              "concreteType": "AtlassianAccountUserExtendedProfile",
              "kind": "LinkedField",
              "name": "extendedProfile",
              "plural": false,
              "selections": (v57/*: any*/)
            }
          ],
          "type": "AtlassianAccountUser"
        },
        (v33/*: any*/)
      ]
    }
  ]
},
v59 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v51/*: any*/),
      "type": "ExternalRepository"
    },
    (v54/*: any*/)
  ]
},
v60 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v61 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v50/*: any*/),
    (v55/*: any*/),
    (v33/*: any*/)
  ]
},
v62 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v60/*: any*/),
        (v37/*: any*/)
      ],
      "type": "ExternalSpace"
    },
    (v54/*: any*/)
  ]
},
v63 = {
  "kind": "ScalarField",
  "name": "externalId"
},
v64 = {
  "kind": "ScalarField",
  "name": "nickname"
},
v65 = {
  "concreteType": "ThirdPartyUserExtendedProfile",
  "kind": "LinkedField",
  "name": "extendedProfile",
  "plural": false,
  "selections": (v57/*: any*/)
},
v66 = [
  (v63/*: any*/),
  (v50/*: any*/),
  (v64/*: any*/),
  (v56/*: any*/),
  (v55/*: any*/),
  (v65/*: any*/),
  (v33/*: any*/)
],
v67 = {
  "concreteType": "ExternalAssociationConnection",
  "kind": "LinkedField",
  "name": "associatedWith",
  "plural": false,
  "selections": [
    {
      "concreteType": "ExternalAssociationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "ExternalAssociation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                (v32/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v66/*: any*/),
                  "type": "ThirdPartyUser"
                },
                (v54/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "channelId",
                      "kind": "ScalarField",
                      "name": "externalId"
                    },
                    (v60/*: any*/)
                  ],
                  "type": "ExternalConversation"
                }
              ]
            },
            (v33/*: any*/)
          ]
        }
      ]
    }
  ]
},
v68 = {
  "kind": "ScalarField",
  "name": "thumbnailUrl"
},
v69 = [
  (v33/*: any*/),
  (v50/*: any*/),
  (v56/*: any*/),
  (v55/*: any*/),
  (v63/*: any*/),
  (v65/*: any*/)
],
v70 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": (v69/*: any*/)
    }
  ]
},
v71 = [
  (v33/*: any*/),
  (v50/*: any*/)
],
v72 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v71/*: any*/)
},
v73 = [
  (v72/*: any*/)
],
v74 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": (v73/*: any*/)
},
v75 = {
  "kind": "ScalarField",
  "name": "memberCount"
},
v76 = [
  (v50/*: any*/),
  (v33/*: any*/)
],
v77 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "owners",
  "plural": true,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": (v76/*: any*/)
    }
  ]
},
v78 = [
  (v77/*: any*/)
],
v79 = {
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/),
        (v60/*: any*/)
      ],
      "type": "ExternalCustomerOrg"
    },
    (v54/*: any*/)
  ]
},
v80 = [
  {
    "kind": "ScalarField",
    "name": "lastActivityAt"
  },
  {
    "kind": "ScalarField",
    "name": "event"
  }
],
v81 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": (v73/*: any*/)
},
v82 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v73/*: any*/)
},
v83 = {
  "kind": "ScalarField",
  "name": "dueDate"
},
v84 = {
  "kind": "ScalarField",
  "name": "status"
},
v85 = {
  "condition": "__relay_internal__pv__jsmdcenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "container",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v40/*: any*/)
          ],
          "type": "ExternalSpace"
        }
      ]
    }
  ]
},
v86 = [
  (v32/*: any*/),
  (v50/*: any*/),
  (v33/*: any*/)
],
v87 = {
  "kind": "ScalarField",
  "name": "workspaceName"
},
v88 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v89 = {
  "kind": "ScalarField",
  "name": "eventEndTime"
},
v90 = {
  "kind": "ScalarField",
  "name": "eventStartTime"
},
v91 = {
  "kind": "ScalarField",
  "name": "videoMeetingUrl"
},
v92 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "initialContributors",
  "plural": true,
  "selections": (v69/*: any*/)
},
v93 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "allContributors",
  "plural": true,
  "selections": (v66/*: any*/)
},
v94 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "allContributors",
  "plural": true,
  "selections": [
    (v50/*: any*/),
    (v64/*: any*/),
    (v56/*: any*/),
    (v55/*: any*/),
    (v63/*: any*/),
    (v65/*: any*/),
    (v33/*: any*/)
  ]
},
v95 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v96 = [
  (v39/*: any*/),
  (v47/*: any*/)
],
v97 = [
  (v39/*: any*/)
],
v98 = {
  "concreteType": "AssetsLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "web"
    }
  ]
},
v99 = {
  "concreteType": "AssetsSchema",
  "kind": "LinkedField",
  "name": "objectSchemaEntity",
  "plural": false,
  "selections": (v76/*: any*/)
},
v100 = [
  {
    "kind": "ScalarField",
    "name": "url48"
  }
],
v101 = [
  (v46/*: any*/),
  (v33/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/)
    ],
    "kind": "Fragment",
    "name": "searchResultsQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "includeAssigneeField",
            "variableName": "includeAssigneeField"
          },
          {
            "kind": "Variable",
            "name": "includeIconUrl",
            "variableName": "includeIconUrl"
          },
          {
            "kind": "Variable",
            "name": "includeNavBoostScore",
            "variableName": "includeNavBoostScore"
          },
          {
            "kind": "Variable",
            "name": "includePositions",
            "variableName": "includePositions"
          },
          {
            "kind": "Variable",
            "name": "includeThirdPartyId",
            "variableName": "includeThirdPartyId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "searchResults_AtlassianSearchPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v21/*: any*/),
      (v2/*: any*/),
      (v29/*: any*/),
      (v19/*: any*/),
      (v8/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v18/*: any*/),
      (v1/*: any*/),
      (v20/*: any*/),
      (v28/*: any*/),
      (v4/*: any*/),
      (v30/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v10/*: any*/),
      (v25/*: any*/),
      (v11/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v12/*: any*/),
      (v14/*: any*/),
      (v16/*: any*/),
      (v13/*: any*/),
      (v17/*: any*/),
      (v15/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isassetsenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jsmdcenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "searchResultsQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "args": (v31/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      {
                        "concreteType": "SearchLinkedResult",
                        "kind": "LinkedField",
                        "name": "linkedResults",
                        "plural": true,
                        "selections": [
                          (v33/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "category"
                          },
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v34/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/)
                        ]
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isSearchResult"
                      },
                      (v36/*: any*/),
                      (v38/*: any*/),
                      (v37/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareLocalizationField",
                                    "kind": "LinkedField",
                                    "name": "localizedLabel",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "messageId"
                                      }
                                    ]
                                  },
                                  (v43/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "score"
                                  }
                                ]
                              },
                              {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": (v45/*: any*/)
                              },
                              (v33/*: any*/),
                              (v46/*: any*/),
                              (v34/*: any*/)
                            ]
                          },
                          (v49/*: any*/)
                        ],
                        "type": "SearchResultAtlasGoal"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isPrivate"
                              },
                              {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "dueDate",
                                "plural": false,
                                "selections": (v45/*: any*/)
                              },
                              {
                                "concreteType": "TownsquareProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": [
                                  (v44/*: any*/),
                                  (v43/*: any*/)
                                ]
                              },
                              (v33/*: any*/),
                              (v46/*: any*/)
                            ]
                          },
                          (v49/*: any*/)
                        ],
                        "type": "SearchResultAtlasProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v39/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "SearchFederatedEmailUser",
                                    "kind": "LinkedField",
                                    "name": "sender",
                                    "plural": false,
                                    "selections": (v51/*: any*/)
                                  }
                                ],
                                "type": "SearchFederatedEmailEntity"
                              }
                            ]
                          }
                        ],
                        "type": "SearchResultFederated"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v39/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "tier"
                          },
                          {
                            "concreteType": "CompassComponent",
                            "kind": "LinkedField",
                            "name": "component",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "state"
                              },
                              (v33/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "ownerId"
                          }
                        ],
                        "type": "SearchResultCompassComponent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v52/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isVerified"
                          },
                          {
                            "concreteType": "SearchConfluenceResultSpace",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v50/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "webUiLink"
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "confluenceEntity",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v40/*: any*/),
                                  {
                                    "concreteType": "ConfluenceCommentCountSummary",
                                    "kind": "LinkedField",
                                    "name": "commentCountSummary",
                                    "plural": false,
                                    "selections": [
                                      (v53/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "ConfluenceLikesSummary",
                                    "kind": "LinkedField",
                                    "name": "likesSummary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "count"
                                      }
                                    ]
                                  }
                                ],
                                "type": "ConfluencePage"
                              },
                              (v54/*: any*/)
                            ]
                          },
                          (v58/*: any*/),
                          (v49/*: any*/),
                          {
                            "condition": "includeNavBoostScore",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "navBoostScore"
                              }
                            ]
                          }
                        ],
                        "type": "SearchConfluencePageBlogAttachment"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v52/*: any*/),
                          (v49/*: any*/)
                        ],
                        "type": "SearchConfluenceSpace"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          (v35/*: any*/),
                          (v41/*: any*/),
                          (v40/*: any*/),
                          (v39/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "permissionLevel"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v50/*: any*/),
                                  (v59/*: any*/)
                                ],
                                "type": "ExternalBranch"
                              },
                              (v54/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v60/*: any*/),
                                          (v37/*: any*/),
                                          (v40/*: any*/)
                                        ],
                                        "type": "ExternalSpace"
                                      },
                                      (v54/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ExternalComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                      (v61/*: any*/)
                                    ]
                                  },
                                  (v59/*: any*/)
                                ],
                                "type": "ExternalCommit"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v62/*: any*/),
                                  {
                                    "concreteType": "ExternalReaction",
                                    "kind": "LinkedField",
                                    "name": "reactions",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "reactionType"
                                      },
                                      (v53/*: any*/)
                                    ]
                                  },
                                  {
                                    "condition": "includeThirdPartyId",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "thirdPartyId"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "ExternalDocumentType",
                                    "kind": "LinkedField",
                                    "name": "type",
                                    "plural": false,
                                    "selections": (v48/*: any*/)
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "parent",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v60/*: any*/)
                                        ],
                                        "type": "ExternalDocument"
                                      },
                                      (v54/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ExternalDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v63/*: any*/),
                                  (v67/*: any*/),
                                  (v34/*: any*/),
                                  {
                                    "concreteType": "ExternalAttachment",
                                    "kind": "LinkedField",
                                    "name": "attachments",
                                    "plural": true,
                                    "selections": [
                                      (v36/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "mimeType"
                                      },
                                      (v37/*: any*/),
                                      (v68/*: any*/),
                                      (v32/*: any*/)
                                    ]
                                  },
                                  (v70/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v60/*: any*/),
                                          (v74/*: any*/),
                                          (v38/*: any*/),
                                          (v33/*: any*/),
                                          (v75/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "membershipType"
                                          }
                                        ],
                                        "type": "ExternalConversation"
                                      },
                                      (v54/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastActive"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "reactionCount"
                                  }
                                ],
                                "type": "ExternalMessage"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v34/*: any*/),
                                  (v60/*: any*/),
                                  (v75/*: any*/),
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": true,
                                    "selections": [
                                      (v32/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ExternalConversation"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v60/*: any*/),
                                  {
                                    "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "concreteType": "ExternalUser",
                                        "kind": "LinkedField",
                                        "name": "contributors",
                                        "plural": true,
                                        "selections": (v73/*: any*/)
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v78/*: any*/)
                                  },
                                  (v79/*: any*/),
                                  {
                                    "concreteType": "ExternalCustomerOrgLastActivity",
                                    "kind": "LinkedField",
                                    "name": "customerOrgLastActivity",
                                    "plural": false,
                                    "selections": (v80/*: any*/)
                                  }
                                ],
                                "type": "ExternalCustomerOrg"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "stage"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "dealClosedAt"
                                  },
                                  {
                                    "concreteType": "ExternalDealLastActivity",
                                    "kind": "LinkedField",
                                    "name": "lastActivity",
                                    "plural": false,
                                    "selections": (v80/*: any*/)
                                  },
                                  {
                                    "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v78/*: any*/)
                                  },
                                  (v79/*: any*/)
                                ],
                                "type": "ExternalDeal"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v81/*: any*/),
                                  (v82/*: any*/),
                                  (v83/*: any*/),
                                  (v46/*: any*/),
                                  (v84/*: any*/),
                                  (v62/*: any*/),
                                  (v85/*: any*/)
                                ],
                                "type": "ExternalProject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v81/*: any*/),
                                  (v82/*: any*/),
                                  (v83/*: any*/),
                                  (v84/*: any*/),
                                  (v40/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "team"
                                  },
                                  (v62/*: any*/),
                                  {
                                    "concreteType": "ExternalWorkItemProject",
                                    "kind": "LinkedField",
                                    "name": "workItemProject",
                                    "plural": false,
                                    "selections": (v71/*: any*/)
                                  },
                                  (v85/*: any*/)
                                ],
                                "type": "ExternalWorkItem"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v36/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastUpdate"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "pullRequestId"
                                  },
                                  (v59/*: any*/)
                                ],
                                "type": "ExternalPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "durationInSeconds"
                                  },
                                  (v68/*: any*/),
                                  {
                                    "concreteType": "ExternalChapter",
                                    "kind": "LinkedField",
                                    "name": "chapters",
                                    "plural": true,
                                    "selections": [
                                      (v36/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "startTimeInSeconds"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": [
                                      (v72/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": (v86/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v33/*: any*/),
                                  (v37/*: any*/),
                                  (v87/*: any*/),
                                  (v77/*: any*/)
                                ],
                                "type": "ExternalDashboard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v33/*: any*/),
                                  (v37/*: any*/),
                                  {
                                    "alias": "dataTableType",
                                    "kind": "ScalarField",
                                    "name": "type"
                                  },
                                  (v87/*: any*/),
                                  (v77/*: any*/)
                                ],
                                "type": "ExternalDataTable"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "accountName"
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "contactUser",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                          (v50/*: any*/),
                                          (v65/*: any*/),
                                          (v33/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalCustomerContact"
                              }
                            ]
                          },
                          (v88/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v82/*: any*/),
                                  (v89/*: any*/),
                                  (v90/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "recurringEventId"
                                  },
                                  (v91/*: any*/)
                                ],
                                "type": "ExternalCalendarEvent"
                              },
                              (v54/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ExternalThumbnail",
                                    "kind": "LinkedField",
                                    "name": "thumbnail",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "externalUrl"
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalDesign"
                              }
                            ]
                          },
                          {
                            "concreteType": "SearchResultGraphDocument",
                            "kind": "LinkedField",
                            "name": "linkedEntities",
                            "plural": true,
                            "selections": [
                              (v33/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v90/*: any*/),
                                      (v89/*: any*/),
                                      (v91/*: any*/)
                                    ],
                                    "type": "ExternalCalendarEvent"
                                  },
                                  (v54/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v70/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "container",
                                        "plural": false,
                                        "selections": [
                                          (v32/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v74/*: any*/),
                                              (v38/*: any*/)
                                            ],
                                            "type": "ExternalConversation"
                                          },
                                          (v54/*: any*/)
                                        ]
                                      },
                                      (v63/*: any*/),
                                      (v67/*: any*/),
                                      (v34/*: any*/)
                                    ],
                                    "type": "ExternalMessage"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/)
                                    ],
                                    "type": "ExternalConversation"
                                  }
                                ]
                              },
                              (v92/*: any*/),
                              (v93/*: any*/),
                              (v88/*: any*/),
                              (v41/*: any*/),
                              (v94/*: any*/)
                            ]
                          },
                          (v93/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "containerName"
                          },
                          (v92/*: any*/),
                          (v94/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "linkedEntitiesType"
                          }
                        ],
                        "type": "SearchResultGraphDocument"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v39/*: any*/),
                          (v47/*: any*/),
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "issueTypeAvatarUrl"
                              },
                              (v95/*: any*/),
                              (v46/*: any*/),
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "ids",
                                    "value": [
                                      "project"
                                    ]
                                  }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v32/*: any*/),
                                          (v50/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": (v71/*: any*/)
                                              }
                                            ],
                                            "type": "JiraProjectField"
                                          },
                                          (v33/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "fieldsById(ids:[\"project\"])"
                              },
                              {
                                "condition": "includeAssigneeField",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "assigneeField",
                                    "plural": false,
                                    "selections": [
                                      (v61/*: any*/),
                                      (v33/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v33/*: any*/)
                            ]
                          }
                        ],
                        "type": "SearchResultJiraIssue"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "projectKey"
                          },
                          (v39/*: any*/),
                          (v47/*: any*/),
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v95/*: any*/),
                              (v33/*: any*/)
                            ]
                          },
                          (v58/*: any*/)
                        ],
                        "type": "SearchResultJiraProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v96/*: any*/),
                        "type": "SearchResultJiraPlan"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v39/*: any*/),
                          (v47/*: any*/),
                          {
                            "concreteType": "JiraBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                              (v47/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "boardFrontendUrl"
                              },
                              (v33/*: any*/)
                            ]
                          }
                        ],
                        "type": "SearchResultJiraBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v96/*: any*/),
                        "type": "SearchResultJiraDashboard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v96/*: any*/),
                        "type": "SearchResultJiraFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "MercuryFocusArea",
                            "kind": "LinkedField",
                            "name": "focusArea",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MercuryFocusAreaStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v46/*: any*/),
                                  (v60/*: any*/),
                                  (v33/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "MercuryFocusAreaHealth",
                                "kind": "LinkedField",
                                "name": "health",
                                "plural": false,
                                "selections": [
                                  (v46/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "color"
                                  },
                                  (v60/*: any*/),
                                  (v33/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "MercuryTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "targetDate"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "targetDateType"
                                  }
                                ]
                              },
                              (v33/*: any*/),
                              (v50/*: any*/),
                              {
                                "concreteType": "MercuryFocusAreaType",
                                "kind": "LinkedField",
                                "name": "focusAreaType",
                                "plural": false,
                                "selections": (v71/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": (v86/*: any*/)
                              }
                            ]
                          },
                          (v39/*: any*/)
                        ],
                        "type": "SearchResultMercuryFocusArea"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v39/*: any*/),
                          {
                            "concreteType": "MercuryFocusArea",
                            "kind": "LinkedField",
                            "name": "focusArea",
                            "plural": false,
                            "selections": (v76/*: any*/)
                          }
                        ],
                        "type": "SearchResultMercuryFocusAreaStatusUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v97/*: any*/),
                        "type": "SearchResultTrelloBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v97/*: any*/),
                        "type": "SearchResultTrelloCard"
                      },
                      {
                        "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v39/*: any*/),
                              {
                                "concreteType": "AssetsSchema",
                                "kind": "LinkedField",
                                "name": "objectSchemaEntity",
                                "plural": false,
                                "selections": [
                                  (v98/*: any*/),
                                  (v33/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObjectSchema"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v39/*: any*/),
                              (v99/*: any*/),
                              {
                                "concreteType": "AssetsObjectType",
                                "kind": "LinkedField",
                                "name": "objectTypeEntity",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "AssetsIcon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": (v100/*: any*/)
                                  },
                                  (v98/*: any*/),
                                  (v33/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObjectType"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v39/*: any*/),
                              (v99/*: any*/),
                              {
                                "concreteType": "AssetsObject",
                                "kind": "LinkedField",
                                "name": "objectEntity",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "AssetsAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": (v100/*: any*/)
                                  },
                                  (v98/*: any*/),
                                  (v33/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObject"
                          }
                        ]
                      },
                      {
                        "condition": "includePositions",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "RadarPosition",
                                "kind": "LinkedField",
                                "name": "position",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  {
                                    "concreteType": "RadarWorker",
                                    "kind": "LinkedField",
                                    "name": "worker",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "preferredName"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v32/*: any*/),
                                          (v55/*: any*/),
                                          (v33/*: any*/)
                                        ]
                                      },
                                      (v33/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "fieldIdIsIn",
                                        "value": [
                                          "positionId",
                                          "positionStatus",
                                          "positionJobTitle",
                                          "positionPositionTitle",
                                          "positionKey",
                                          "positionExternalPositionKey",
                                          "positionWorker",
                                          "focusArea"
                                        ]
                                      }
                                    ],
                                    "concreteType": "RadarFieldValueIdPair",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "fieldValue",
                                        "plural": false,
                                        "selections": [
                                          (v32/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "stringValue",
                                                "kind": "ScalarField",
                                                "name": "value"
                                              }
                                            ],
                                            "type": "RadarStringFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "value",
                                                "plural": false,
                                                "selections": [
                                                  (v32/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v50/*: any*/),
                                                      {
                                                        "concreteType": "MercuryFocusAreaStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": (v101/*: any*/)
                                                      },
                                                      {
                                                        "concreteType": "MercuryFocusAreaHealth",
                                                        "kind": "LinkedField",
                                                        "name": "health",
                                                        "plural": false,
                                                        "selections": (v101/*: any*/)
                                                      }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                  },
                                                  (v54/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "RadarAriFieldValue"
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                  },
                                  (v33/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultTalentPosition"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "SearchQueryInfo",
                "kind": "LinkedField",
                "name": "queryInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "originalQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "replacementQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "suggestedQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "originalQueryType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "confidenceScore"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "shouldTriggerAutocorrectionExperience"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "concreteType": "SearchError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "product"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "integration"
                  }
                ]
              }
            ]
          },
          {
            "args": (v31/*: any*/),
            "filters": [
              "experience",
              "enableHighlighting",
              "query",
              "sort",
              "disableQueryReplacement",
              "fanoutExperimentCohort",
              "filters",
              "analytics",
              "experimentContext"
            ],
            "handle": "connection",
            "key": "SearchResultsPagination__search",
            "kind": "LinkedHandle",
            "name": "search"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "473880706f8cc6ebfcd6c2018f3381a21889aba1dd03ede8065fc008d2d9b5cb",
    "metadata": {},
    "name": "searchResultsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
      "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": isCustomerOrgOwnersEnabled_provider,
      "__relay_internal__pv__isdealownersenabledrelayprovider": isDealOwnersEnabled_provider,
      "__relay_internal__pv__jsmdcenabledrelayprovider": isJsmDcEnabled_provider
    }
  }
};
})();

(node as any).hash = "2241d83732d506b402c827513317ca25";

export default node;
